<template>
  <div>
    <!-- 詢價單查詢 -->
    <SearchBar @doSearchEvent="doSearchEvent" />
    <CCard>
      <CCardBody>
        <div class="table-container">
          <vue-bootstrap4-table
            ref="supplierSearchBs4Table"
            class=""
            :rows="rows"
            :columns="columns"
            @on-change-query="onChangeQuery"
            :total-rows="totalCount"
            :config="config"
            :classes="classes"
          >
            <template v-if="isTw" slot="empty-results"> 查無結果 </template>
            <template v-if="isTw" slot="pagination-info" slot-scope="props">
              {{ paginationInfoTwText(props) }}
            </template>
            <template slot="func" slot-scope="props">
              <button
                class="btn btn-sm btn-success mr-2"
                @click="detail(props.row)"
              >
                {{ detailBtnText(props.row) }}
              </button>
              <button
                class="btn btn-sm btn-warning mr-2"
                @click="requireFileModal(props.row.id)"
              >
                {{ i18n("Request_Vue.RequirementsFile") }}
              </button>
              <button
                class="btn btn-sm btn-warning"
                @click="quoteFileModal(props.row.id)"
                v-if="
                  props.row.isQuotation === '是' &&
                  (props.row.status === '結案' ||
                    props.row.status === '作廢' ||
                    props.row.status === '指定結案')
                "
              >
                {{ i18n("QuoteInfo_Vue.QuotationAttachment") }}
              </button>
            </template>
          </vue-bootstrap4-table>
        </div>
      </CCardBody>
    </CCard>

    <!-- 報價附件 Modal -->
    <div
      class="modal fade"
      id="quoteFileModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            {{ $t("QuoteInfo_Vue.QuotationAttachment") }}
          </div>
          <div class="modal-body">
            <table class="table">
              <thead class="thead-light">
                <tr>
                  <th
                    class="text-center"
                    v-for="header in QuoteFileTableHeader"
                    :key="header"
                  >
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in quoteFileList" :key="item.id">
                  <td class="text-center">{{ index + 1 }}</td>
                  <td class="text-center">{{ item.fileName }}</td>
                  <td class="text-center fileDownload">
                    <a @click="downloadQuoteFile(item.id)">下載</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-gray" data-dismiss="modal">
              {{ $t("Buttons.Cancel") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 需求附件 Modal -->
    <div
      class="modal fade"
      id="requireFileModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            {{ $t("Request_Vue.RequirementsFile") }}
          </div>
          <div class="modal-body">
            <table class="table">
              <thead class="thead-light">
                <tr>
                  <th
                    class="text-center"
                    v-for="header in requireFileTableHeader"
                    :key="header"
                  >
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in requireFileList" :key="item.id">
                  <td class="text-center">{{ item.index }}</td>
                  <td class="text-center">{{ item.productName }}</td>
                  <td class="text-center">{{ item.spec }}</td>
                  <td class="text-center">{{ item.brand }}</td>
                  <td class="text-center">{{ item.productNo }}</td>
                  <td class="text-center">{{ item.fileIndex }}</td>
                  <td class="text-center">{{ item.fileName }}</td>
                  <td class="text-center fileDownload">
                    <a @click="downloadRequireFile(item.id)">下載</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-gray" data-dismiss="modal">
              {{ $t("Buttons.Cancel") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import SearchBar from "./SearchBar";
import { mapGetters } from "vuex";
import { Notification } from "element-ui";
export default {
  components: {
    SearchBar,
  },
  data() {
    return {
      rows: [],
      totalCount: 0,
      filter: { pageSize: 10, pageIndex: 1 },
      requestQueryParam: {},
      columns: [
        {
          label: this.i18n("Request_Vue.FactoryType"),
          name: "factoryId",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.StartDate"),
          name: "createTime",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.QuoteNo"),
          name: "inquiryNo",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Version"),
          name: "version",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.InquiryName"),
          name: "inquiryName",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Currency"),
          name: "currency",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Deadline"),
          name: "inquiryEndDate",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Purchaser"),
          name: "purchaseName",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Status"),
          name: "status",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Quotation"),
          name: "isQuotation",
          row_text_alignment: "text-left",
        },
        { label: this.i18n("Request_Vue.Function"), name: "func" },
      ],
      config: {
        card_mode: false,
        show_refresh_button: false,
        show_reset_button: false,
        // server_mode: true, // by default false
        per_page: 10, // default 10
        per_page_options: [10, 25, 50],
        global_search: {
          visibility: false,
        },
      },
      classes: {
        cell: {
          "text-danger": function (row, column, cellValue) {
            return column.name == "isQuotation" && row.isQuotation === "是";
          },
        },
      },
      QuoteFileTableHeader: [
        // 報價附件表格標題
        this.i18n("Request_Vue.No"),
        this.i18n("Request_Vue.FileName"),
        this.i18n("Request_Vue.Download"),
      ],
      quoteFileList: [
        {
          id: "1",
          FileName: "附件名稱",
        },
        {
          id: "2",
          FileName: "附件名稱",
        },
      ],
      requireFileTableHeader: [
        // 需求附件表格標題
        this.i18n("Request_Vue.RequirementsIndex"),
        this.i18n("Request_Vue.ProductName"),
        this.i18n("Request_Vue.Specification"),
        this.i18n("Request_Vue.Brand"),
        this.i18n("Request_Vue.Type"),
        this.i18n("Request_Vue.FileIndex"),
        this.i18n("Request_Vue.FileName"),
        this.i18n("Request_Vue.Download"),
      ],
      requireFileList: [],
    };
  },
  props: {},
  watch: {
    lang: function () {
      (this.columns = [
        {
          label: this.i18n("Request_Vue.FactoryType"),
          name: "factoryName",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.StartDate"),
          name: "createTime",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.QuoteNo"),
          name: "inquiryNo",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Version"),
          name: "version",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.InquiryName"),
          name: "inquiryName",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Currency"),
          name: "currency",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Deadline"),
          name: "inquiryEndDate",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Purchaser"),
          name: "purchaseName",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Status"),
          name: "status",
          row_text_alignment: "text-left",
        },
        {
          label: this.i18n("Request_Vue.Quotation"),
          name: "isQuotation",
          row_text_alignment: "text-left",
        },
        { label: this.i18n("Request_Vue.Function"), name: "func" },
      ]),
        (this.QuoteFileTableHeader = [
          // 報價附件表格標題
          this.i18n("Request_Vue.No"),
          this.i18n("Request_Vue.FileName"),
          this.i18n("Request_Vue.Download"),
        ]),
        (this.requireFileTableHeader = [
          // 需求附件表格標題
          this.i18n("Request_Vue.RequirementsIndex"),
          this.i18n("Request_Vue.ProductName"),
          this.i18n("Request_Vue.Specification"),
          this.i18n("Request_Vue.Brand"),
          this.i18n("Request_Vue.Type"),
          this.i18n("Request_Vue.FileName"),
          this.i18n("Request_Vue.Download"),
        ]);
    },
  },
  methods: {
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    // 查詢 詢價單 Api
    doSearchEvent(val) {
      if (this.$refs.supplierSearchBs4Table) {
        this.$refs.supplierSearchBs4Table.page = 1;
      }

      const $fixDate = this.fixDate;

      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/RequestMaster`;
      const params = {
        ...val,
        VendorId: this.$userInfo.vendorId,
      };

      this.updateLoading(true);

      this.axios.get(api, { params }).then((response) => {
        // console.log("詢價單", response);

        if (response.status === 200) {
          this.updateLoading(false);
          if (response.data.errorMessage) {
            Notification({
              title: "失敗",
              message: response.data.errorMessage,
              type: "error",
              duration: 5000,
            });
          } else {
            // vm.rows = response.data;
            vm.rows = response.data.map((item) => {
              let factoryName = "";
              if (item.factoryId === "KH" || item.factoryId === "KW") {
                factoryName = "高雄廠";
              } else if (item.factoryId === "SZ") {
                factoryName = "蘇州廠";
              } else if (item.factoryId === "NJ") {
                factoryName = "南京廠";
              } else if (item.factoryId === "GZ") {
                factoryName = "廣州廠";
              } else if (item.factoryId === "VH") {
                factoryName = "越南義安廠";
              }
              let createTime = $fixDate(item.createTime);
              let inquiryEndDate = $fixDate(item.inquiryEndDate);

              let isQuotation = "";
              if (item.isQuotation) {
                isQuotation = "是";
              } else {
                isQuotation = "否";
              }

              return {
                ...item,
                factoryId: factoryName,
                createTime: createTime,
                inquiryEndDate: inquiryEndDate,
                isQuotation: isQuotation,
              };
            });
            vm.totalCount = vm.rows.length;
            vm.requestQueryParam = val;
          }
        }
      });
    },

    // 分頁搜尋
    onChangeQuery(queryParams) {
      // let search = this.requestQueryParam;
      // search.pageSize = queryParams.per_page;
      // search.pageIndex = queryParams.page;
      // //須用此方式提供 語系對應功能函數
      // search.func = (key) => this.$t(key);
      // search.fixDate = this.fixDate;
      // this.doSearchEvent(search);
    },

    // 分頁中文資訊
    paginationInfoTwText(props) {
      const vm = this;
      let page = vm.$refs.supplierSearchBs4Table.page;
      let pageCount = vm.$refs.supplierSearchBs4Table.per_page;

      let startRecNo = 0;
      let endRecNo = 0;

      if (vm.totalCount && vm.totalCount > 0) {
        startRecNo = 1 + (page - 1) * pageCount;
        endRecNo = startRecNo + pageCount - 1;
        if (endRecNo > vm.totalCount) {
          endRecNo = vm.totalCount;
        }
        return `第 ${startRecNo}筆 ~ 第 ${endRecNo}筆資料列(共${props.originalRowsLength}筆)`;
      } else {
        return "無任何資料列";
      }
    },

    // 按鈕顯示 (報價/詳情資訊)
    detailBtnText(row) {
      const today = new Date().yyyymmdd();
      if (
        row.status === "廠商報價中" &&
        row.inquiryEndDate &&
        row.inquiryEndDate > today
      ) {
        return this.i18n("Buttons.Quote");
      } else {
        //報價截止日期<系統當日時，供應商不得於ROE平台上進行報價，或案件已經關閉
        return this.i18n("Buttons.DetailInfo");
      }
    },

    // 詳細資訊
    detail(row) {
      //this.$store.dispatch('alertMessageModule/updateMessage', { message: '已成功登入', status: 'success' });
      this.$router.push({
        path: "/supplieredit",
        query: { requestMasterId: row.id },
      });
    },

    // 需求附件 Api
    requireFileModal(id) {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/RequestDetail`;
      this.updateLoading(true);

      let params = {
        RequestMasterId: id,
      };

      vm.requireFileList = [];

      this.axios.get(api, { params }).then((response) => {
        // console.log("需求附件", response.data.requestDetails);
        this.updateLoading(false);
        if (response.data.requestDetails) {
          response.data.requestDetails.map((item, index) => {
            item.requestDetailFiles.map((file, fileIndex) => {
              vm.requireFileList.push({
                index: index + 1,
                productName: item.productName,
                spec: item.spec,
                brand: item.brand,
                productNo: item.productNo,
                fileIndex: fileIndex + 1,
                fileName: file.fileName,
                id: file.id,
              });
            });
          });
          $("#requireFileModal").modal("show");
        } else {
          $("#requireFileModal").modal("show");
        }
      });
    },

    // 下載 需求附件 Api
    downloadRequireFile(id) {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/GetFile/${id}`;

      vm.axios.get(api, { responseType: "blob" }).then((response) => {
        const filename = decodeURIComponent(
          decodeURIComponent(
            response.headers["content-disposition"].split(
              "filename*=UTF-8''"
            )[1]
          )
        );
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },

    // 報價附件 Api
    quoteFileModal(id) {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/RequestDetail`;
      this.updateLoading(true);

      let params = {
        RequestMasterId: id,
        VendorId: this.$userInfo.vendorId,
      };

      vm.quoteFileList = [];

      this.axios.get(api, { params }).then((response) => {
        // console.log("報價附件", response.data.requestSupplierFiles);
        this.updateLoading(false);
        if (response.data.requestSupplierFiles) {
          response.data.requestSupplierFiles.map((item) => {
            vm.quoteFileList.push({
              ...item,
            });
          });
          $("#quoteFileModal").modal("show");
        } else {
          $("#quoteFileModal").modal("show");
        }
      });
    },

    // 下載 報價附件 Api
    downloadQuoteFile(id) {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestSupplier/GetFile/${id}`;

      vm.axios.get(api, { responseType: "blob" }).then((response) => {
        const filename = decodeURIComponent(
          decodeURIComponent(
            response.headers["content-disposition"].split(
              "filename*=UTF-8''"
            )[1]
          )
        );
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },
  },
  computed: {
    // isAdmin() {
    //   return false;
    // },
    ...mapGetters(["lang"]),
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
table th:first-child {
  text-align: center;
  padding: 15px 5px;
}
.fileDownload {
  color: #409eff;
  cursor: pointer;
}
.btn-gray {
  background-color: gray;
  color: white;
}
.btn-warning {
  color: #fff;
}
</style>